import type { JSONContent } from '@tiptap/core';

// -- conversationPlayback ------------------------------------------------------
// Shared playback model for the admin conversation previews (the Flow Editor
// simulation and the units-page learning-material preview). The speeds
// themselves come from CONVERSATION_PLAYBACK_SPEEDS, so the previews animate at
// exactly the speeds a student can choose, plus an admin-only "show all at once"
// mode. Students never get the instant mode: they must experience the paced
// conversation.

// A playback selection is either an animated speed multiplier or the admin-only
// instant mode that renders the whole conversation at once.
export type PlaybackSpeed = number | 'instant';

const WORD_REGEX = /\s+/;

function wordsInBlock(block: JSONContent): number {
  let words = 0;
  if (block.content) {
    for (const content of block.content) {
      if (content.content) {
        for (const innerContent of content.content) {
          if (innerContent.text) {
            words += innerContent.text.trim().split(WORD_REGEX).length;
          }
        }
      }
    }
  }
  return words;
}

// Returns how long to pause before revealing the next block. In instant mode the
// delay is zero so the whole conversation appears immediately.
export function getBlockAnimationDelayMS(block: JSONContent, speed: PlaybackSpeed): number {
  if (speed === 'instant') {
    return 0;
  }
  // Average adult reading speed is 200-250 words per minute.
  const AVERAGE_READING_SPEED = 225 * speed; // words per minute
  const AVERAGE_READING_TIME_WORD_MS = 60 / AVERAGE_READING_SPEED;
  const MIN_MESSAGE_DELAY_MS = 1000;
  return Math.max(
    MIN_MESSAGE_DELAY_MS,
    wordsInBlock(block) * AVERAGE_READING_TIME_WORD_MS * MIN_MESSAGE_DELAY_MS,
  );
}
